import { IconFileDollar, IconLayoutKanban, IconUserDollar } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';

import type { Menu } from '../types';

export function useBuildKanbanMenu(): Menu {
  const { t } = useTranslation();

  return useMemo(() => {
    const items = [
      {
        path: '/kanban/invoices',
        label: t(i18nKeys.KANBAN.INVOICE.TITLE),
        Icon: IconFileDollar,
      },
      {
        path: '/kanban/customers',
        label: t(i18nKeys.KANBAN.DEBTOR.TITLE),
        Icon: IconUserDollar,
      },
    ];

    return {
      parent: null,
      label: t(i18nKeys.NAV.SUMMARY_TABLE),
      Icon: IconLayoutKanban,
      path: '/kanban/invoices',
      items,
    };
  }, [t]);
}
